<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <Modal
    @on-ok="ok2(1)"
    :mask-closable="false" 
    @on-cancel="modal3 = false;isSaving = false;
    isSaving2 = false;"
    v-model="modal3"
    title="微小加工和处理"
  >
  <p slot="header" style="color:#333; font-size:16px">
       
    <span>微小加工和处理</span>
 </p>
    <div
      v-for="(item, index) in ftaData"
      :key="`page-${index}`"
      v-if="modal3index == index"
    >
      <div style="margin-bottom: 20px; font-size:14px; font-weight:bold;">
        请确认商品加工过程是否超出(
        <span style="color:red">{{ item.fta }}</span
        >)微小加工和处理
      </div>
      <p
        style="margin-bottom: 10px;font-size: 15px;
  white-space: pre-wrap;font"
        v-html="item.content"
      ></p>

      <Button
        type="primary"
        style="margin-right: 5px;"
        @click="modal3index = index - 1"
        :disabled="modal3index == 0"
        >上一页</Button
      >
      <RadioGroup v-model="ftaData[index].satisfyFlag">
        <Poptip
         v-model="visible"
          confirm
          title="请确认，生产该商品仅使用了列表中所列的加工方式"
          @on-cancel="ftaData[index].satisfyFlag = 0"
        >
          <Radio :label="1"> <span @click="visible=true" style="display:inline-block;width:50px;text-align:left;font-size: 15px;"> 不超出</span></Radio>
        </Poptip>

        <Radio :label="0"><span @click="visible=false" style="display:inline-block;width:50px;text-align:left;font-size: 15px;"> 超出</span></Radio>
      </RadioGroup>
     
      <Button
        type="primary"
        @click="modal3index = index + 1"
        :disabled="modal3index == ftaData.length - 1"
        >下一页</Button
      >
    </div>
    <div slot="footer">
      <span style="float: left; font-size:15px"
      >当前第{{ modal3index + 1 }}页,共{{ ftaData.length }} 页</span
    >
    <Button
      type="primary"
      size="large"
      :disabled="modal3index != ftaData.length - 1"
      @click="ok2(1)"
      >确定</Button
    >
    <Button type="ghost" size="large" @click="modal3 = false;isSaving = false;
    isSaving2 = false;cloasemodal3=false;
    ftaData=[]">取消</Button>
     
    </div>
  
  </Modal>
  <Modal  @on-cancel="modal4 = false;isSaving = false;isSaving2 = false;"  :mask-closable="false"  v-model="modal4" title="加工工序/化学反应">
    <div
      v-for="(item, index) in processData"
      :key="`page-${index}`"
      v-if="modal4index == index"
    >
      <div style="margin-bottom: 20px; font-size:14px; font-weight:bold;">
        {{ item.ftaName }}
      </div>
      <p
        style="margin-bottom: 10px;
white-space: pre-wrap;font-size: 15px;"
        v-html="item.show"
      ></p>

      <Button
        type="primary"
        style="margin-right: 5px;"
        @click="modal4index = index - 1"
        :disabled="modal4index == 0"
        >上一页</Button
      >
      <RadioGroup v-model="processData[index].satisfyFlag">
        <Radio :label="1"><span style="font-size: 15px;">满足</span></Radio>
        <Radio :label="0"><span style="font-size: 15px;">不满足</span></Radio>
      </RadioGroup>

      <Button
        type="primary"
        @click="modal4index = index + 1"
        :disabled="modal4index == processData.length - 1"
        >下一页</Button
      >
    </div>
    <div slot="footer">
        <span style="float: left; font-size:15px"
        >当前第{{ modal4index + 1 }}页,共{{ processData.length }} 页</span
      >
      <Button
        type="primary"
        size="large"
        :disabled="modal4index != processData.length - 1"
        @click="ok2(2)"
        >确定</Button
      >
      <Button type="ghost" size="large" @click="modal4 = false;isSaving = false;
      isSaving2 = false;">取消</Button>
    </div>
    
  </Modal>
    <div class="inv_product boxshadow1">
      <div class="slogo-title">新增成品</div>
      <div class="product">
        <Form
          ref="form"
          :model="product"
          :rules="productForm"
          @submit.native.prevent
        >
          <Row :gutter="16" class="line1">
         
         
           
            <Col span="6" class="exporter">
              <FormItem >
                <span class="title">进口国/地区<span style="color:red">*</span></span>
                <Export
                      v-model="product.importer"
                  
                      :width="'200%'"
                      styleName="n"
                    ></Export>
              </FormItem>
            </Col>
            <Col span="6" class="exporter">
              <FormItem >
                <span class="title">原产国/地区<span style="color:red">*</span></span>
                <Export
                      v-model="product.exporter"
                    
                      :width="'200%'"
                      styleName="n"
                    ></Export>
              </FormItem>
            </Col>
            <Col span="6" class="exporter">
              <FormItem >
                <span class="title">发票号</span>
                <Input
                  v-model.trim="product.invoiceCode"
                  clearable
                  placeholder="请填写发票号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="6" class="pn">
              <FormItem >
                <span class="title ttooltip">
                  产品中文名称
                  <Tooltip content="可输入成品名称、成品料号进行辅助输入">
                    <svg-icon icon-class="help"></svg-icon>
                  </Tooltip>
                </span>
                <XAutoComplete
                  v-model.trim="product.goodsName"
                  @on-search="handleSearch"
                  :transfer="false"
                  @on-focus="handleFocus"
                  icon="ios-more"
                  clearable
                  placeholder="请填写成品名称"
                  ref="autoCompleteName"
                >
                  <Option
                    v-for="item in books"
                    :value="item.goodsName"
                    :key="item.id"
                    class="coo_autocomplete_option"
                  >
                    <div @click.prevent="handleSelect(item.id)">
                      {{ item.goodsPN }}-{{ item.goodsName }}
                    </div>
                  </Option>
                </XAutoComplete>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2">
            <Col span="6" class="importer">
              <FormItem >
                <span class="title">产品料号</span>
                <Input
                  v-model.trim="product.goodsPN"
                  clearable
                  placeholder="请填写成品料号"
                ></Input>
              </FormItem>
            </Col>
            <Col span="6" class="name">
              <FormItem prop="goodsCode">
                <!-- <span class="title">成品商品编码</span> -->
                <span class="title ttooltip">
                  产品HS编码<span style="color:red">*</span>
                  <Tooltip content="可输入商品编码、拼音、汉字进行辅助输入">
                    <svg-icon icon-class="help"></svg-icon>
                  </Tooltip>
                </span>
                <!-- <Input v-model.trim="product.goodsCode" clearable placeholder="请填写成品商品编码"></Input> -->
                <div :class="['inputs', 'clearfix']" @keyup="escProductEvent">
                  <Product
                    class="pr"
                    ref="pr"
                    :currentState="'hscode'"
                    placeholderText="请填写成品商品编码"
                    noFoundMsg="请填写正确的成品商品编码"
               
                    @onInput="onProductInput"
                  ></Product>
                </div>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem prop="goodsWeight">
                <span class="title">产品重量</span>
                <div>
                  <!-- <Input v-model.trim="product.goodsWeight" clearable placeholder="请填写成品重量"></Input> -->
                  <InputNumber style="width:100%"
                      :min="0.001"
                      v-input-limit="3"
                      v-model.trim="product.goodsWeight"
                      placeholder="请填写产品重量"
                    ></InputNumber>
                  <!-- <Select
                    v-model="product.weightUnit"
                    transfer
                    class="tgroup_item2"
                  >
                    <Option
                      v-for="item in weightUnitArr"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select> -->
                </div>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem >
                <span class="title">产品重量计量单位 </span>
                <div>
                  <Select clearable
                  v-model="product.weightUnit"
                  transfer
                  class="tgroup_item"
                >
                <Option
                v-for="item in weightUnitArr"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
                </Select>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2">
             <Col span="6" class="key">
              <FormItem >
                <span class="title">单位产品离岸价格<span style="color:red">*</span></span>
                <div >
                  <InputNumber  style="width:100%"
                  :min="0.001"
                
                  v-input-limit='3'
                   v-model="product.goodsPrice" clearable 
                 ></InputNumber>
                </div>
              </FormItem>
            </Col> 
            <Col span="6" class="key">
              <FormItem >
                <span class="title">货币币制</span>
                <div>
                  <Select v-model="product.unit" transfer >
                    <Option
                      v-for="item in ['CNY', 'USD']"
                      :value="item"
                      :key="item"
                      >{{ item }}</Option
                    >
                  </Select>
                </div>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem >
                <span class="title">简单加工商品</span>
                <div>
                  <Select
                      disabled
                      v-model="product.simpleProcess"
                      transfer
                   
                    >
                      <Option :value="1">是</Option>
                      <Option :value="0">否</Option>
                    </Select>
                </div>
              </FormItem>
            </Col>
         
          </Row>
          <Row :gutter="16" class="line2">
            <Col span="12" class="key remark">
              <FormItem >
                <span class="title">备注</span>
                <Input
                  v-model.trim="product.goodsDescription"
                  clearable
                  placeholder="请填写备注"
                ></Input>
              </FormItem>
            </Col>
            <Col span="12" class="key remark">
              <FormItem >
                <span class="title">加工工序/化学反应</span>
                <Input
                  v-model.trim="product.specialCraftContent"
                
                  disabled
                
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2" v-if="isShowSpecialCraft">
            <!-- <Col span="6" class="key">
              <FormItem prop="goodsCount">
                <span class="title">成品数量</span>
                <Input v-model.trim="product.goodsCount" clearable placeholder="请填写成品数量"></Input>
              </FormItem>
            </Col> -->
            <!-- <Col span="6" class="key" style="height: 65px;">
                <span class="title">完全获取</span>
                <RadioGroup v-model="product.wo">
                  <Radio label="Y"><span>是</span></Radio>
                  <Radio label="N"><span>否</span></Radio>
                </RadioGroup>
            </Col> -->
            <Col span="24" class="key specialgy">
              <FormItem >
                <div class="title">
                  <Checkbox
                    v-model="product.specialCraft"
                    :true-value="'Y'"
                    :false-value="'N'"
                    >加工工序</Checkbox
                  >
                </div>
                <div class="scdesc">{{ specialCraftDesc }}</div>
              </FormItem>
              <!-- <RadioGroup v-model="product.specialCraft">
                <Radio label="Y"><span>是</span></Radio>
                <Radio label="N"><span>否</span></Radio>
              </RadioGroup> -->
            </Col>
          </Row>
        </Form>
      </div>
      <Row
      :gutter="16"
      class="line2"
      v-if="product.specialCodes && product.specialCodes.length"
      style="margin-top:20px"
    >
      <div
        v-for="(item, index) in product.specialCodes"
        :key="index"
        class="specialCodes"
      >
        <span style="font-size: 15px;">{{ item.goodsDesc }}</span>
        <span class="center">
          <RadioGroup v-model="item.specialVal">
            <Radio :label="1"><span style="font-size: 15px;">是</span></Radio>
            <Radio :label="0"><span style="font-size: 15px;">否</span></Radio>
          </RadioGroup>
        </span>
        <span>{{ item.fta }}</span>
      </div>
    </Row>
    </div>

    <!--<div class="files" v-if="files.list.length > 0">-->
    <!--<Table :columns="files.columns" :data="files.list" no-data-text="暂无记录"></Table>-->
    <!--</div>-->

    <div class="inv_actions boxshadow1">
      <div class="actions">
        <!--<Button type="ghost" shape="circle" class="upload" :loading="uploading" icon="ios-search"><span>上传附件</span></Button>-->
        <!-- <Button type="ghost" shape="circle" class="add" icon="ios-search" @click.prevent="cooModalData={};isShowModal=true">新增原材料</Button> -->
      
        
        <Button
          type="ghost"
          shape="circle"
          class="add"
          icon="ios-search"
          @click.prevent="
          cooModalData = {
            materialUnit: product.unit,
            weightUnit: product.weightUnit
          };
          isShowModal = true;
        "
          >新增原材料</Button
        >
        <Button 
        type="ghost"
        shape="circle"
        class="edit"
        icon="ios-edit" 
        @click.prevent="editcooModalData"
        >修改</Button
      >

      <Poptip confirm title="你确定要执行删除操作吗?" @on-ok="delMaterial">
        <Button
        type="ghost"
        shape="circle"
        class="del"
        icon="ios-search"
          >删除</Button
        >
      </Poptip>
       
       
      </div>
    </div>

    <div class="inv_material boxshadow1">
      <div class="material_list">
        <div class="table-containter">
          <div class="table-wrap">
            <Table
              :columns="query.columns"
              :data="query.list"
              no-data-text="暂无记录"
              @on-selection-change="selectionChange"
            ></Table>
          </div>
        </div>
      </div>
    </div>
    <div class="btns">
      <Button style="background-color: #8892f3;border-color:#8892f3" type="primary" class="btn" :loading="isSaving" @click.prevent="ok"
        ><span>保存</span></Button
      >
      <Button style="background-color: #bc8cf0;border-color:#bc8cf0" 
        type="primary"
        class="btn"
        :loading="isSaving2"
        @click.prevent="ok2(0)"
        ><span>保存并判定</span></Button
      >
    </div>
    <CooModal
    :materialOriginArr="materialOriginArr"
    :isShow="isShowModal"
    :dataSet="cooModalData"
    @changeState="isShowModal = $event"
  ></CooModal>
    <DoingModal :isShow="isShowDoingModal" :index="doingStep"></DoingModal>
    <Loader
      :loadType="1"
      v-show="isShowModalLoader"
      class="black"
      style="top:-20px;"
    ></Loader>
  </div>
</template>

<script>
import _ from "lodash";
import Export from "@/components/common/Export3";
import BigNumber from "bignumber.js";
import CooModal from "./cooModal";
import Loader from "@/components/layout/Loader";
import DoingModal from "./doingModal";
import Product from "@/components/common/Product2";
import { createNamespacedHelpers, mapMutations } from "vuex";
const {
  mapState: mapDataState,
  mapGetters: mapDataGetters
} = createNamespacedHelpers("data");

export default {
 
  name: "InvoiceMaterialAddContent",
  components: { CooModal, Loader, DoingModal, Product, Export },
  props: {
    mh: {
      type: Number
    }
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{3})$/
    
      if(!reg.test(value)){
            callback(new Error('小数位数最多为3位'))
           
      }
      else {
        callback();
      }
    };
    const validWeight = (rule, value, callback) => {
      
      if (value) {
        value = parseFloat(this._.trim(`${value}`));
        if (this._.isNaN(value) || value <= 0 || !this.product.weightUnit) {
          callback(new Error("请正确填写成品重量/单位"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let _this = this;
    return {
      visible:false,
      timeout: null,
      materialOriginArr: [],
      cloasemodal3: false,
      data: {},
      ftaData: [],
      processData: [],
      row: {},
      modal3: false,
      modal4: false,
      modal1: false,
      isShowDoingModal: false,
      doingStep: 0,
      doingTimer: null,
      // uploading: false,
      isShowSpecialCraft: false,
      isShowModal: false,
      cooModalData: {},
      selectedID: [],
      isSaving: false,
      isSaving2: false,
      books: [],
      isShowModalLoader: false,
      weightUnitArr: [
        { name: "吨", value: "t" },
        { name: "千克", value: "kg" },
        { name: "克", value: "g" },
        { name: "毫克", value: "mg" },
        { name: "微克", value: "ug" },
        { name: "磅", value: "b" },
        { name: "盎", value: "oz" }
      ],
      specialCraftDesc: "",
      simpleProduct: "N",
      product: {
        specialCodes: [],
        // companyCode: '',
        importer: "",
        exporter: "",
        invoiceCode: "",
        goodsPN: "",
        goodsName: "",
        goodsCode: "",
        goodsPrice: null,

        // goodsCount: '',
        goodsWeight: 0,
        weightUnit: "kg",
        unit: "CNY",
        goodsDescription: "",
        imported: "N",
        // wo: 0,
        // specialCraft: 0
        // wo: 'N',
        specialCraft: "N",
        simpleProcess: 0
      },
      productForm: {
      
        goodsCode: [
          { required: true, message: "请填写成品商品编码", trigger: "change" }
        ],
       
  
        goodsWeight: [
          // { required: true, type: 'number', message: '请填写成品重量/单位', trigger: 'blur' },
          { validator: validWeight, trigger: "change" }
        ]
       
      },

      editMtl_ID: 0,
      modal3index: 0,
      modal4index: 0,
      editMtl_ID: 0,
      query: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "原材料料号",
            key: "materialPN",
            align: "center",
            minWidth: 120,
            ellipsis: true,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h("Input", {
                  class: `input-pn-${params.row._id}`,
                  props: {
                    value: params.row.materialPN,
                    placeholder: "请填写",
                    autofocus: true
                  }
                });
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialPN } },
                  params.row.materialPN
                );
              }
            }
          },
          {
            title: "原材料属性",
            key: "materialType",
            align: "center",
            minWidth: 130,
            ellipsis: true,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h(
                  "Select",
                  {
                    class: `input-ty-${params.row._id}`,
                    ref: `input-ty-${params.row._id}`,
                    props: {
                      value: params.row.materialType,
                      placeholder: "请选择"
                    }
                  },
                  [
                    _.map(
                      this.$options.filters.getMaterialType("", true),
                      (v, k) => {
                        return h("Option", { props: { value: k, label: v } });
                      }
                    )
                  ]
                );
              } else {
                return h(
                  "span",
                  {
                    attrs: {
                      title: this.$options.filters.getMaterialType(
                        params.row.materialType
                      )
                    }
                  },
                  this.$options.filters.getMaterialType(params.row.materialType)
                );
              }
            }
          },
          {
            title: "原材料名称",
            key: "materialName",
            align: "center",
            minWidth: 120,
            ellipsis: true,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h("Input", {
                  class: `input-nm-${params.row._id}`,
                  props: {
                    value: params.row.materialName,
                    placeholder: "请填写"
                  }
                });
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialName } },
                  params.row.materialName
                );
              }
            }
          },
          {
            title: "原材料商品编码",
            key: "materialCode",
            align: "center",
            ellipsis: true,
            minWidth: 120,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h("Input", {
                  class: `input-cd-${params.row._id}`,
                  props: {
                    value: params.row.materialCode,
                    placeholder: "请填写"
                  }
                });
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialCode } },
                  params.row.materialCode
                );
              }
            }
          },
          {
            title: "原材料单价",
            key: "materialPrice",
            align: "center",
            minWidth: 180,
            ellipsis: true,
            render: (h, params) => {
              let text =
                (_this.$options.filters.amountThousands2(
                  params.row.materialPrice || 0
                ) || "-") + params.row.materialUnit;
              if (params.row._id == _this.editMtl_ID) {
                return h("div", { class: ["tgroup_wrap_tb"] }, [
                  h("InputNumber", {
                    class: `input-pr-${params.row._id}`,
                    props: {
                      value: params.row.materialPrice || null,
                      placeholder: "请填写",
                      min: 0.01
                    }
                  }),
                  h(
                    "Select",
                    {
                      class: [`input-pu-${params.row._id}`, "tgroup_item2"],
                      props: {
                        value: params.row.materialUnit,
                        placeholder: "请选择"
                      }
                    },
                    [
                      _.map(_this.mtrPriceUnitArr || ["CNY", "USD"], v => {
                        return h("Option", { props: { value: v, label: v } });
                      })
                    ]
                  )
                ]);
              } else {
                return h("span", { attrs: { title: text } }, text);
              }
            }
          },
          // { title: '原材料单位', key: 'materialUnit', align: 'center', width: 100 },
          {
            title: "原材料重量",
            key: "materialWeight",
            align: "center",
            ellipsis: true,
            minWidth: 180,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                let [weight, weightUnit] = _this.splitWeightUnit(
                  params.row.materialWeight || ""
                );
                return h("div", { class: ["tgroup_wrap_tb"] }, [
                  h("InputNumber", {
                    class: `input-wt-${params.row._id}`,
                    props: {
                      value: weight || null,
                      placeholder: "请填写",
                      min: 0.01
                    }
                  }),
                  h(
                    "Select",
                    {
                      class: [`input-wu-${params.row._id}`, "tgroup_item2"],
                      props: { value: weightUnit, placeholder: "请选择" }
                    },
                    [
                      _.map(_this.weightUnitArr, v =>
                        h("Option", {
                          props: { value: v.value, label: v.name }
                        })
                      )
                    ]
                  )
                ]);
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialWeight || "-" } },
                  params.row.materialWeight || "-"
                );
              }
            }
          },
          {
            title: "原材料原产地",
            key: "materialOrigin",
            align: "center",
            ellipsis: true,
            minWidth: 120,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h("Input", {
                  class: `input-or-${params.row._id}`,
                  props: {
                    value: params.row.materialOrigin,
                    placeholder: "请填写"
                  }
                });
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialOrigin } },
                  params.row.materialOrigin
                );
              }
            }
          },
          {
            title: "原材料备注",
            key: "materialDescription",
            align: "center",
            ellipsis: true,
            minWidth: 200,
            render: (h, params) => {
              if (params.row._id == _this.editMtl_ID) {
                return h("Input", {
                  class: `input-rm-${params.row._id}`,
                  props: {
                    value: params.row.materialDescription,
                    placeholder: "请填写"
                  }
                });
              } else {
                return h(
                  "span",
                  { attrs: { title: params.row.materialDescription || "-" } },
                  params.row.materialDescription || "-"
                );
              }
            }
          }
        ],
        list: []
      }
    };
  },

  computed: {
    ...mapDataState(["productReady"]),
    mtrPriceUnitArr() {
      return this.product.unit ? [this.product.unit] : ["CNY", "USD"];
    }
  },
  watch: {
    "product.importer"(newVal) {
      if (this._.trim(newVal)) {
        // this.checkShowSpecialCraft();
      } else {
        this.product.specialCraft = "";
        this.isShowSpecialCraft = false;
      }
    },
    "product.exporter"(newVal) {
      if (this._.trim(newVal)) {
        // this.checkShowSpecialCraft();
      } else {
        this.product.specialCraft = "";
        this.isShowSpecialCraft = false;
      }
    },
    "product.goodsCode"(newVal) {
      if (this._.trim(newVal)) {
        this.initInputValue();
      } else {
        this.product.specialCodes = [];
        this.product.specialCraft = "";
        this.isShowSpecialCraft = false;
      }
    },
    "product.weightUnit"(newVal) {
      if (newVal) {
        this.query.list = this._.map(this.query.list, item => {
          let [weight, weightUnit] = this.splitWeightUnit(
            item["materialWeight"] || ""
          );

          item["materialWeight"] = weight
            ? weight + this.product.weightUnit
            : "";
          return item;
        });
      } else {
        this.query.list = this._.map(this.query.list, item => {
          item["materialWeight"] = "";
          return item;
        });
      }
    },
    "product.unit"(newVal) {
      if (newVal) {
        this.query.list = this._.map(this.query.list, item => {
          item["materialUnit"] = newVal;
          return item;
        });
      }
    },
    productReady(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.initInputValue();
        }, 200);
      }
    },
    isShowSpecialCraft(newVal) {
      if (!newVal) {
        this.specialCraftDesc = "";
      }
    }
  },
  activated() {
    let _this = this;
    this.$api.getSearchDictData({
      success(response) {
        if (response.data.code === 200) {
          _this.materialOriginArr = response.data.data.exporter.allArea;
        }
      }
    });
    this.$refs.pr.setDefaultValue({
      id: "",
      text: "",
      _level: 0
    });
    this.query.list = [];
    this.product = {
      specialCodes: [],

      // companyCode: '',
      importer: "",
      exporter: "",
      invoiceCode: "",
      goodsPN: "",
      goodsName: "",
      goodsCode: "",
      goodsPrice: null,

      // goodsCount: '',
      goodsWeight: 0,
      weightUnit: "kg",
      unit: "CNY",
      goodsDescription: "",
      imported: "N",
      // wo: 0,
      // specialCraft: 0
      // wo: 'N',
      specialCraft: "N",
      simpleProcess: 0
    };
    this.$refs["form"].resetFields();
    this.requestData();
    if (this.$route.query.d) {
      this.$api.coo.goods.get(this.$route.query.d, {
        success: response => {
          if (response.data.code === 200) {
            let _data = response.data.data;
            _.forEach(this.product, (value, key) => {
              if (key == "goodsWeight") {
                let [weight, weightUnit] = this.splitWeightUnit(
                  _data[key] || ""
                );
                this.product[key] = weight;
                this.product["weightUnit"] = weightUnit;
              } else if (["imported", "specialCraft"].indexOf(key) != -1) {
                this.product[key] =
                  _data[key] == 1 || _data[key] == "Y" ? "Y" : "N";
              } else if (key != "weightUnit") {
                this.product[key] = _data[key];
              }
            });
            if (_data.materials && _data.materials.length > 0) {
              _(_data.materials).forEach(value => {
                value["_id"] = this._h.getRandomStr(32);
                this.query.list.push(
                  _.omit(value, ["id", "memberId", "goodsId", "status"])
                );
              });
            }
          }
        },
        error: errorMsg => {}
      });
    } else {
    }
  },
  created() {
    let _this = this;
    this.$api.getSearchDictData({
      success(response) {
        if (response.data.code === 200) {
          _this.materialOriginArr = response.data.data.exporter.allArea;
        }
      }
    });

    this.requestData();
    if (this.$route.query.d) {
      this.$api.coo.goods.get(this.$route.query.d, {
        success: response => {
          if (response.data.code === 200) {
            let _data = response.data.data;

            _.forEach(this.product, (value, key) => {
              if (key == "goodsWeight") {
                let [weight, weightUnit] = this.splitWeightUnit(
                  _data[key] || ""
                );
                this.product[key] = weight;
                this.product["weightUnit"] = weightUnit;
              } else if (["imported", "specialCraft"].indexOf(key) != -1) {
                this.product[key] =
                  _data[key] == 1 || _data[key] == "Y" ? "Y" : "N";
              } else if (key != "weightUnit") {
                this.product[key] = _data[key];
              }
            });
            if (_data.materials && _data.materials.length > 0) {
              _(_data.materials).forEach(value => {
                value["_id"] = this._h.getRandomStr(32);
                this.query.list.push(
                  _.omit(value, ["id", "memberId", "goodsId", "status"])
                );
              });
            }
          }
        },
        error: errorMsg => {}
      });
    } else {
    }
  },
  methods: {
    
    limitDecimalsF (value){
      const reg = /^(\-)*(\d+)\.(\d\d).*$/;
    console.log(value);
    if(typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
    } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
    } else {
        return ''
    }
  },


    ...mapMutations(["closeTag"]),
    editcooModalData() {
      if (!this.selectedID || this.selectedID.length != 1) {
        this.$Message.error({
          content: "请选择一条数据1",
          closable: false
        });
        return;
      }
      for (let index = 0; index < this.query.list.length; index++) {
        if (this.query.list[index]._id == this.selectedID[0]) {
     
          this.cooModalData = {
            ...this.query.list[index],
            materialUnit: this.product.unit,
            weightUnit: this.product.weightUnit
          };

          this.isShowModal = true;
        }
      }
    },
    requestData() {
      let that = this;

      
    },

    saveEditStatus_Mtr(row) {
      let pn = _.trim(
        document.querySelector(`.input-pn-${row._id} input`).value || ""
      );
      if (!pn) {
        this.$Message.info({
          content: "请填写原材料料号",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let ty = _.trim(
        document.querySelector(`.input-ty-${row._id} input`).value || ""
      );
      if (!ty) {
        this.$Message.info({
          content: "请选择原材料属性",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let nm = _.trim(
        document.querySelector(`.input-nm-${row._id} input`).value || ""
      );
      if (!nm) {
        this.$Message.info({
          content: "请填写原材料名称",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let cd = _.trim(
        document.querySelector(`.input-cd-${row._id} input`).value || ""
      );
      if (!cd) {
        this.$Message.info({
          content: "请填写原材料商品编码",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let pr = parseFloat(
        _.trim(document.querySelector(`.input-pr-${row._id} input`).value || "")
      );
      let pu = _.trim(
        document.querySelector(`.input-pu-${row._id} input`).value || ""
      );
      if (
        !pr ||
        _.isNaN(pr) ||
        pr <= 0 ||
        !pu ||
        !this.$options.filters.isPrice(`${pr}`)
      ) {
        this.$Message.info({
          content: "请正确填写原材料单价/单位",
          duration: 1.5,
          closable: true
        });
        return;
      }
      if (this.product.unit != pu) {
        this.$Message.info({
          content: "原材料价格单位与成品价格单位不一致",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let wt = document.querySelector(`.input-wt-${row._id} input`).value || "";
      let wu = _.trim(
        document.querySelector(`.input-wu-${row._id} input`).value || ""
      );
      if (wt) {
        wt = parseFloat(_.trim(wt));
        if (!wt || _.isNaN(wt) || wt <= 0 || !wu) {
          this.$Message.info({
            content: "请正确填写原材料重量/单位",
            duration: 1.5,
            closable: true
          });
          return;
        }
      }
      let orn = _.trim(
        document.querySelector(`.input-or-${row._id} input`).value || ""
      );
      if (!orn) {
        this.$Message.info({
          content: "请填写原材料原产地",
          duration: 1.5,
          closable: true
        });
        return;
      }
      let remark = _.trim(
        document.querySelector(`.input-rm-${row._id} input`).value || ""
      );
      let lastEditRowIdx = _.findIndex(
        this.query.list,
        o => o._id == this.editMtl_ID
      );
      let _data_ = {
        materialPN: pn,
        materialType: ty,
        materialName: nm,
        materialCode: cd,
        materialPrice: pr,
        materialUnit: pu,
        materialOrigin: orn,
        materialWeight: wt ? wt + wu : "",
        materialDescription: remark
      };
      if (lastEditRowIdx != -1) {
        if (this.editMtl_ID != -1) {
          this.$set(
            this.query.list,
            lastEditRowIdx,
            _.assign(
              _.omit(this.query.list[lastEditRowIdx], ["_disabled"]),
              _data_
            )
          );
        } else {
          this.$set(
            this.query.list,
            lastEditRowIdx,
            _.assign(
              _.omit(this.query.list[lastEditRowIdx], ["_disabled"]),
              _data_,
              {
                _id: this._h.getRandomStr(32)
              }
            )
          );
        }
      }
      this.editMtl_ID = 0;
    },
    cancelEditStaus_Mtr(row) {
      let lastEditRowIdx = _.findIndex(
        this.query.list,
        o => o._id == this.editMtl_ID
      );
      if (this.editMtl_ID != -1 && lastEditRowIdx != -1) {
        this.$set(
          this.query.list,
          lastEditRowIdx,
          _.omit(this.query.list[lastEditRowIdx], ["_disabled"])
        );
      } else if (lastEditRowIdx != -1) {
        this.$delete(this.query.list, lastEditRowIdx);
      }
      this.editMtl_ID = 0;
    },
    setEditStatus_Mtr(row) {
      if (this.editMtl_ID != 0) this.cancelEditStaus_Mtr(row);
      let currentEditRowIdx = _.findIndex(
        this.query.list,
        o => o._id == row._id
      );
      if (currentEditRowIdx != -1) {
        this.$set(
          this.query.list,
          currentEditRowIdx,
          _.assign(this.query.list[currentEditRowIdx], { _disabled: true })
        );
      }
      this.editMtl_ID = row._id;
    },
    del_Mtr(row) {
      let idx = _.findIndex(this.query.list, o => o._id == row._id);
      if (idx != -1) {
        this.$delete(this.query.list, idx);
      }
    },
    onProductInput(val) {
      if (this.timeout !== null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$api.getOriginGoodsSpecialList(val, {
          success: response => {
            if (response.data.code === 200) {
             
              if (response.data.data.length) {
                this.product.specialCodes = response.data.data;
              } else {
                this.product.specialCodes = [];
              }
            } else {
              this.product.specialCodes = [];
            }
          },
          error: errorMsg => {
            this.product.specialCodes = [];
          }
        });
      }, 500);

      this.product.goodsCode = this._.trim(val || "");
      this.$refs["form"].validate("goodsCode");
    },
    escProductEvent(event) {
      if (event && event.keyCode === 27) {
        this.$refs.pr && this.$refs.pr.closeDowndown(true);
      }
    },

    ...mapDataGetters(["getProductByCode"]),
    initInputValue() {
      if (this.product.goodsCode) {
        let item = this.getProductByCode()(this.product.goodsCode);
        if (!this._.isEmpty(item)) {
          this.$refs.pr.setDefaultValue({
            id: item.code,
            text: item.name,
            _level: item._level
          });
        } else {
          this.$refs.pr.setDefaultValue({
            id: this.product.goodsCode,
            text: this.product.goodsCode,
            _level: 0
          });
        }
      }
    },

    splitWeightUnit(val) {
      if (this._.trim(val)) {
        let reg = /[a-zA-Z]+?$/;
        if (reg.test(val)) {
          let tmp = val.match(reg)[0],
            tmp2 = val.replace(tmp, "");

          tmp =
            this.weightUnitArr.findIndex(item => item.value == tmp) != -1
              ? tmp
              : "";
          return [parseFloat(tmp2) || null, tmp];
        }
      }
      return [null, ""];
    },
   
    handleSearch: _.debounce(function(value) {
      value = this._.trim(value || "");
      
      this.$api.coo.goods.list(
        this._.assign({ page: 1, size: 10 }, value ? { key: value } : {}),
        {
          success: response => {
            if (response.data.code === 200) {
              this.books = response.data.data.result || [];
            }
            else {
              this.$Message.warning({
                content: response.data.message,
                duration: 1.5,
                closable: true
              });
            }
          }
        }
      );
    }, 350),
    handleSelect(id) {
      if (!this.isShowModalLoader) {
        // let id = this._.split(value, '-', 1)[0]
        id = this._.trim(id || "");
        if (id) {
          this.isShowModalLoader = true;
          this.$api.coo.goods.get(id, {
            success: response => {
              this.$Loading.finish();
              if (response.data.code === 200) {
                let [weight, weightUnit] = this.splitWeightUnit(
                  response.data.data.goodsWeight || ""
                );

                this.product = {
                  ...this.product,

                  specialCodes: [],

                  // companyCode: response.data.data.companyCode,
                  importer: response.data.data.importer,
                  exporter: response.data.data.exporter,
                  // invoiceCode: response.data.data.invoiceCode,
                  invoiceCode: "",
                  goodsPN: response.data.data.goodsPN,
                  goodsName: response.data.data.goodsName,
                  goodsCode: response.data.data.goodsCode,
                  goodsPrice: response.data.data.goodsPrice,
                  // goodsWeight: response.data.data.goodsWeight,
                  goodsWeight: weight,
                  weightUnit: weightUnit,
                  unit: response.data.data.unit || "CNY",
                  goodsDescription: response.data.data.goodsDescription || "",
                  imported:
                    response.data.data.imported == 1 ||
                    response.data.data.imported == "Y"
                      ? "Y"
                      : "N"
                  // goodsCount: response.data.data.goodsCount || '',
                  // wo: parseInt(response.data.data.wo) ? 1 : 0,
                  // specialCraft: parseInt(response.data.data.specialCraft) ? 1 : 0
                  // wo: response.data.data.wo ? 'Y' : 'N',
                  // specialCraft:
                  //   response.data.data.specialCraft == 1 ||
                  //   response.data.data.specialCraft == "Y"
                  //     ? "Y"
                  //     : "N"
                };
                this.query.list = this._.map(
                  response.data.data.materials || [],
                  item => {
                    item["_id"] = this._h.getRandomStr(32);
                    return item;
                  }
                );
                this.editMtl_ID = 0;
              } else {
                this.$Message.warning({
                  content: this.$t("common.codeError"),
                  duration: 1.5,
                  closable: true
                });
              }
              this.isShowModalLoader = false;
            },
            error: errorMsg => {
              this.isShowModalLoader = false;
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                duration: 1.5,
                closable: true
              });
              this.$Loading.error();
            }
          });
        }
      }
    },

    handleFocus: _.debounce(function() {
      if (!this.books || this.books.length === 0) {
        let value = this._.trim(this.product.goodsName || "");
        this.$api.coo.goods.list(
          this._.assign({ page: 1, size: 10 }, value ? { key: value } : {}),
          {
            success: response => {
              if (response.data.code === 200) {
                this.books = response.data.data.result || [];
              }
              else {
              this.$Message.warning({
                content: response.data.message,
                duration: 1.5,
                closable: true
              });
            }
            }
          }
        );
      }
    }, 350),
    ok(step = 1) {
      this.product.goodsCode = this._.trim(this.$refs.pr.text || "");

      if (step === 2 && this.product.simpleProcess === "1") {
        this.$Message.info({
          content: "简单加工商品不满足原产判定资格",
          duration: 2,
          closable: true
        });
      } else {
        if (!this.isSaving && !this.isSaving2) {
          this.$refs["form"].validate(valid => {
            if (valid) {
              if (this.query.list.length > 0 && this.editMtl_ID == 0) {
                if (step === 2) {
                  this.isSaving2 = true;
                } else {
                  this.isSaving = true;
                }
                this.$Loading.start();
                // this.$Message.loading({content: '正在保存', duration: 0})

                let _productData = this._.assign({}, this.product);
                _productData["goodsWeight"] = _productData["goodsWeight"]
                  ? _productData["goodsWeight"] + _productData["weightUnit"]
                  : "";
                _productData = _.omit(_productData, [
                  "companyCode",
                  "goodsCount",
                  "wo",
                  "weightUnit"
                ]);
                // _productData.wo = _productData.wo === 'Y' ? 'Y' : ''
                _productData.imported =
                  _productData.imported === "Y" ? "Y" : "";
                _productData.specialCraft =
                  _productData.specialCraft === "Y" ? "Y" : "";

                let allmaterialPrice = 0;
                let allmaterialWeight = 0;
                let flag = true;

                this.query.list.map(item => {
                  if (_productData.unit != item.materialUnit) {
                    flag = false;
                  }
                  allmaterialPrice = BigNumber(item.materialPrice).plus(
                    allmaterialPrice
                  );

                  if (item.materialWeight) {
                    allmaterialWeight = BigNumber(
                      item.materialWeight.split("kg")[0]
                    ).plus(allmaterialWeight);
                  }
                });
                if (!flag) {
                  this.$Message.error({
                    content: "原材料币制必须和成品币制相同",
                    duration: 1.5,
                    closable: true
                  });
                  this.isSaving = false;
                  this.isSaving2 = false;
                  return;
                }

                if (_productData.goodsPrice < allmaterialPrice) {
                  this.$Message.error({
                    content: "成品金额不能小于原材料金额之和",
                    duration: 1.5,
                    closable: true
                  });
                  this.isSaving = false;
                  this.isSaving2 = false;
                  return;
                }
                if (_productData.goodsCode.length < 6) {
                  this.$Message.error({
                    content: "产品hs编码不能小于6位",
                    duration: 1.5,
                    closable: true
                  });
                  this.isSaving = false;
                  this.isSaving2 = false;
                  return;
                }
                for (
                  let index = 0;
                  index < this.product.specialCodes.length;
                  index++
                ) {
                  if (
                    !this.product.specialCodes[index].specialVal &&
                    this.product.specialCodes[index].specialVal != 0
                  ) {
                    this.$Message.error({
                      content:
                        this.product.specialCodes[index].goodsDesc + "的值必选",
                      duration: 1.5,
                      closable: true
                    });
                    this.isSaving = false;
                    this.isSaving2 = false;
                    return;
                  }
                }

                for (let index = 0; index < this.query.list.length; index++) {
                  if (
                    this.query.list[index].materialType == "e-cost" ||
                    this.query.list[index].materialType == "e-profit"
                  ) {
                    this.query.list[index].materialOrigin =
                      _productData.exporter;
                  }
                }

                this.$api.coo.goods.add(
                  this._.assign({}, _productData, {
                    materials: this.query.list
                  }),
                  {
                    success: response => {
                      this.$Loading.finish();
                      // this.$Message.destroy()
                      if (response.data.code === 200) {
                        if (step === 2 && response.data.data.id) {
                          this.$router.push({
                            path: "/rules/decide/edit/" + response.data.data.id
                          });
                          this.cooHandle(response.data.data.id);
                        } else {
                          this.$router.push({
                            path: "/rules/decide/edit/" + response.data.data.id
                          });
                          this.closeTag(this.$route);
                          this.$Message.success({
                            content: "保存成功",
                            duration: 1.5,
                            closable: true,
                            onClose: () => {
                              // this.$refs['form'] && this.$refs['form'].resetFields()
                              // this.query.list = []
                              this.isSaving = false;
                              this.isSaving2 = false;
                            }
                          });
                        }
                      } else {
                        this.$Message.warning({
                          content: response.data.msg,
                          duration: 1.5,
                          closable: true
                        });
                        this.isSaving = false;
                        this.isSaving2 = false;
                      }
                    },
                    error: errorMsg => {
                      this.isSaving = false;
                      this.isSaving2 = false;
                      this.$Message.error({
                        content: this.$t("common.tryAgain"),
                        duration: 1.5,
                        closable: true
                      });
                      this.$Loading.error();
                    }
                  }
                );
              } else {
                this.$Message.destroy();
                this.$Message.info({
                  content:
                    this.editMtl_ID != 0
                      ? "请保存编辑中的原材料信息"
                      : "请添加成品的原材料信息",
                  duration: 1.5,
                  closable: true
                });
              }
            } else {
              this.$Message.info({
                content: "请检查必填项",
                duration: 1.5,
                closable: true
              });
            }
          });
        }
      }
    },
    ok2(fromtanchuang) {
      this.product.goodsCode = this._.trim(this.$refs.pr.text || "");

      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (this.query.list.length > 0 && this.editMtl_ID == 0) {
            this.isSaving2 = true;
         

            let _productData = this._.assign({}, this.product);
            _productData["goodsWeight"] = _productData["goodsWeight"]
              ? _productData["goodsWeight"] + _productData["weightUnit"]
              : "";
            _productData = _.omit(_productData, [
              "companyCode",
              "goodsCount",
              "wo",
              "weightUnit"
            ]);
            // _productData.wo = _productData.wo === 'Y' ? 'Y' : ''
            _productData.imported = _productData.imported === "Y" ? "Y" : "";
            // _productData.specialCraft =
            //   _productData.specialCraft === "Y" ? "Y" : "";

            let allmaterialPrice = 0;
            let allmaterialWeight = 0;

            let flag = true;

            this.query.list.map(item => {
              if (_productData.unit != item.materialUnit) {
                flag = false;
              }
              allmaterialPrice = BigNumber(item.materialPrice).plus(
                allmaterialPrice
              );

              if (item.materialWeight) {
                allmaterialWeight = BigNumber(
                  item.materialWeight.split("kg")[0]
                ).plus(allmaterialWeight);
              }
            });
            if (!flag) {
              this.$Message.error({
                content: "原材料币制必须和成品币制相同",
                duration: 1.5,
                closable: true
              });
              this.isSaving = false;
              this.isSaving2 = false;
              return;
            }
            if (_productData.goodsPrice < allmaterialPrice) {
              this.$Message.error({
                content: "成品金额不能小于原材料金额之和",
                duration: 1.5,
                closable: true
              });
              this.isSaving = false;
              this.isSaving2 = false;
              return;
            }

            if (_productData.goodsCode.length < 6) {
              this.$Message.error({
                content: "产品hs编码不能小于6位",
                duration: 1.5,
                closable: true
              });
              this.isSaving = false;
              this.isSaving2 = false;
              return;
            }

            for (
              let index = 0;
              index < this.product.specialCodes.length;
              index++
            ) {
              if (
                !this.product.specialCodes[index].specialVal &&
                this.product.specialCodes[index].specialVal != 0
              ) {
                this.$Message.error({
                  content:
                    this.product.specialCodes[index].goodsDesc + "的值必选",
                  duration: 1.5,
                  closable: true
                });
                this.isSaving = false;
                this.isSaving2 = false;
                return;
              }
            }

           
            if(fromtanchuang==0){
              this.ftaData = []
              this.processData = []
              this.modal3index = 0
              this.modal4index = 0
              
              this.modal4 = false
              // this.buttonconfirm1 == false
              let _ftaData =  await this.$api.coo.goods.getAdditional2({
                exporterName: this.product.exporter,
                importerName: this.product.importer,
                  type: 2
                })

              let _processData = await this.$api.coo.goods.getProcessingProcedure( {hsCode:this.product.goodsCode,exporterName:this.product.exporter,importerName:this.product.importer})
         
              if (_ftaData.data.data.length > 0) {
                for (
                  let index = 0;
                  index < _ftaData.data.data.length;
                  index++
                ) {
                  _ftaData.data.data[index].satisfyFlag = 0;
                }
              }
              this.ftaData = _ftaData.data.data;
              this.processData = _processData.data.data;
              if(this.ftaData.length>0){
                this.modal3 = true
             
              }
              if(this.ftaData.length==0 && this.processData.length>0){
                this.modal4 = true
              }
              if(this.ftaData.length==0 && this.processData.length==0){
                
                this.panding(_productData)
              }
              

            }
            if(fromtanchuang==1 && this.processData.length>0){
         
              this.modal3 = false
              this.modal4 = true
              this.modal4index = 0
              return
            }
            if(fromtanchuang==1 && this.processData.length==0){
                this.panding(_productData)

            }
            if(fromtanchuang==2 ){
          
           
              let processDataflag = true;
            
              for (let index = 0;index < this.processData.length;index++) {
                  if (
                    !this.processData[index].satisfyFlag &&
                    this.processData[index].satisfyFlag != 0
                  ) {
                    processDataflag = false;
                  }
              }
              if (processDataflag == false) {
                
                this.$Message.error('加工工序有数据没有选择')
                return;
              }
              else{
                this.modal4 = false
                this.panding(_productData)

              }
              

              

            }






          } else {
            this.$Message.destroy();
            this.$Message.info({
              content:
                this.editMtl_ID != 0
                  ? "请保存编辑中的原材料信息"
                  : "请添加成品的原材料信息",
              duration: 1.5,
              closable: true
            });
          }
        } else {
          this.$Message.info({
            content: "请检查必填项",
            duration: 1.5,
            closable: true
          });
        }
      });
    },
    panding(_productData){
                if (this.ftaData.length > 0) {
                  _productData.simpleProcess == 1;
                }
                if (this.processData.length > 0) {
                  _productData.specialCraft == "Y";
                }
                for (let index = 0; index < this.query.list.length; index++) {
                  const element = this.query.list[index];

                  if (
                    this.query.list[index].materialType == "e-cost" ||
                    this.query.list[index].materialType == "e-profit"
                  ) {
                    this.query.list[index].materialOrigin =
                      _productData.exporter;
                  }
                }
                this.$api.coo.goods.add(
                  this._.assign({}, _productData, {
                    materials: this.query.list
                  }),
                  {
                    success: response => {
                  
                      // this.$Message.destroy()
                      if (response.data.code === 200) {
                        if (response.data.data.id) {
                          this.cooHandle(response.data.data.id);
                        } else {
                          this.$router.push({
                            path: "/rules/decide"
                          });
                          this.$Message.success({
                            content: "保存成功",
                            duration: 1.5,
                            closable: true,
                            onClose: () => {
                              this.isSaving2 = false;
                            }
                          });
                        }
                      } else {
                        this.$Message.warning({
                          content: response.data.msg,
                          duration: 1.5,
                          closable: true
                        });
                        this.isSaving = false;
                        this.isSaving2 = false;
                      }
                    },
                    error: errorMsg => {
                      this.isSaving = false;
                      this.isSaving2 = false;
                      this.$Message.error({
                        content: this.$t("common.tryAgain"),
                        duration: 1.5,
                        closable: true
                      });
                    
                    }
                  }
                );

    },
    cooHandle(id) {
      if (this.isShowDoingModal) return;
      this.$Loading.start();
      this.doingStep = 0;
      this.isShowDoingModal = true;
      this.doingTimer = setTimeout(() => {
        this.doingStep = 1;
        this.doingTimer = setTimeout(() => {
          this.doingStep = 2;
        }, this._.random(1000, 2000));
      }, this._.random(200, 800));

      let data = this.query.list.find(item => {
        return item.id == this.selectedID[0];
      });
      this.$api.coo.determination.submit(
        id,

        { ftaData: this.ftaData, processData: this.processData },
        {
          success: response => {
            this.setDoingState(() => {
              this.$Loading.finish();
              this.$Message.destroy();
              if (response.data.code === 200) {
                setTimeout(() => {
                  this.$Message.success({ content: "操作成功" });
                  this.$router.push({
                    path:
                      "/rules/decide/vote/result/" + response.data.data.id + "/0",
                    query: { type: 0 }
                  });

                  this.isSaving = false;
                  this.isSaving2 = false;
                }, 1000);
              } else {
                this.$Message.warning({
                  content: "判定失败请稍后重试",
                  duration: 1.5,
                  closable: true,
                  onClose: () => {
                    this.$router.push({ path: "/rules/decide" });
                    this.isSaving = false;
                    this.isSaving2 = false;
                  }
                });
              }
            });
          },
          error: errorMsg => {
            this.setDoingState(() => {
              this.$Message.error({
                content: this.$t("common.tryAgain"),
                duration: 1.5,
                closable: true,
                onClose: () => {
                  this.$router.push({ path: "/rules/decide" });
                  this.isSaving = false;
                  this.isSaving2 = false;
                }
              });
              this.$Loading.error();
            });
          }
        }
      );
    },
    setDoingState(callback) {
      if (this.doingTimer !== null) {
        clearTimeout(this.doingTimer);
        if (this.doingStep === 0) {
          this.doingStep = 1;
          setTimeout(() => {
            this.doingStep = 2;
            setTimeout(() => {
              this.doingStep = 3;
              setTimeout(() => {
                this.isShowDoingModal = false;
                callback && callback();
              }, 800);
            }, this._.random(1000, 1500));
          }, this._.random(200, 800));
        } else if (this.doingStep === 1) {
          this.doingStep = 2;
          setTimeout(() => {
            this.doingStep = 3;
            setTimeout(() => {
              this.isShowDoingModal = false;
              callback && callback();
            }, 800);
          }, this._.random(1000, 2500));
        } else if (this.doingStep === 2) {
          this.doingStep = 3;
          setTimeout(() => {
            this.isShowDoingModal = false;
            callback && callback();
          }, 800);
        }
      }
    },

    addMaterial(material, _id) {
      this.selectedID = [];
      if (_id) {
        this.query.list = this._.map(this.query.list, item => {
          if (item._id === _id) {
            material["_id"] = _id;
            return material;
          } else {
            return item;
          }
        });
      } else {
        material["_id"] = this._h.getRandomStr(32);
        this.query.list.push(material);
      }
    },
    delMaterial() {
      if (this.selectedID && this.selectedID.length > 0) {
        this.query.list = this._.filter(
          this.query.list,
          item => this._.indexOf(this.selectedID, item._id) === -1
        );
        this.selectedID = [];
      } else {
        this.$Message.warning({
          content: "请选择需要删除的项",
          duration: 1.5,
          closable: true
        });
      }
    },
    selectionChange(selection) {
      if (selection) {
        this.selectedID = this._.map(selection, item => item._id);
      }
    }
  }
};
</script>
<style>
.coo_autocomplete_option.ivu-select-item {
  padding: 0;
}
.coo_autocomplete_option.ivu-select-item div {
  padding: 7px 16px;
  font-size: 16px;
}
</style>
<style>
  .coo_autocomplete_option.ivu-select-item{
    padding: 0;
  }
  .coo_autocomplete_option.ivu-select-item div{
    padding: 7px 16px;
    font-size: 16px;
  }
</style>
<style scoped>
  .invoice_container{
    background-color: #fff;
    /* padding: 18px 16px 25px; */
  }
  .inv_product{
    padding: 18px 18px 24px;
  }
  .inv_actions,.inv_material{
    margin-top: 30px;
    padding: 18px;
  }
  .slogo-title{
    color: #333;
    font-weight: bold;
    font-size: 16px;
    padding: 0 18px 0 0;
    margin-bottom: 6px;
  }
  .product{
    font-size: 14px;
  }
  .product >>> .ivu-checkbox-wrapper{
    font-size: 16px;
  }
  .product >>> .ivu-checkbox-wrapper .ivu-checkbox{
    margin-right: 5px;
  }
  .product >>> .ivu-select-dropdown.ivu-auto-complete{
    height: 200px;
  }
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar-track-piece {
  background: transparent;
}
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar {
  width: 6px;
}
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
  .product >>> .ivu-input-wrapper .ivu-input-icon{
    line-height: 32px !important;
    width: 32px;
    height: 32px;
  }
  .product >>> .ivu-form-item{
    margin-bottom: 0;
    width: 90%;
  }
  .product >>> .ivu-col.remark .ivu-form-item{
    width: 95.3%;
  }
  .product >>> .ivu-col.specialgy .ivu-form-item{
    width: 98.5%;
  }
  .product >>> .scdesc{
    background-color: #e6f1fd;
    border-radius: 6px;
    display: inline-block;
    padding: 5px 10px;
    line-height: 26px;
    font-size: 14px;
  }
  .product >>> .ivu-form-item-error-tip{
   
    left: 0;
    bottom: 0px;
    padding-top: 0;
    font-size: 13px;
  }
  .product>>>.ivu-form-item-content {
   
    padding-bottom: 10px;
   }
  .product >>> .ivu-row{
    margin-bottom: 12px;
  }
  .product >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .product >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
    height: 100%;
  }
  .product >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
    font-size: 16px;
  }
  .product >>> .ivu-row .ivu-col .ivu-input,
  .product >>> .ivu-row .ivu-col .ivu-input-number,
  .product >>> .ivu-row .ivu-col .ivu-select-selection{
    border-color: #b1b1b1;
    border-radius: 2px;
    font-size: 16px;
  }
   >>>.ivu-poptip-confirm .ivu-poptip-footer{
    display: flex;
  }
  .product >>> .ivu-select-selected-value,
  .product >>> .ivu-select-item{
    font-size: 16px !important;
  }
  .product >>> .ivu-row .ivu-col .ivu-form-item-error .ivu-input{
    border-color: #ed3f14;
  }
  .product >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  .actions{
    position: relative;
  }
  .actions .add{
    border: 1px solid #bc8cf0;
    background-color: #bc8cf0;
    color: #fff;
    margin-right: 20px;
  }
  >>>.ivu-btn-primary.disabled, .ivu-btn-primary.disabled.active, .ivu-btn-primary.disabled:active, .ivu-btn-primary.disabled:focus, 
  .ivu-btn-primary.disabled:hover, .ivu-btn-primary[disabled], .ivu-btn-primary[disabled].active, .ivu-btn-primary[disabled]:active, 
  .ivu-btn-primary[disabled]:focus, .ivu-btn-primary[disabled]:hover, fieldset[disabled] .ivu-btn-primary, fieldset[disabled] 
  .ivu-btn-primary.active, fieldset[disabled] .ivu-btn-primary:active, fieldset[disabled] .ivu-btn-primary:focus, fieldset[disabled] .ivu-btn-primary:hover{
    color: #bbbec4;
    background-color: #f7f7f7;
    border-color: #dddee1;
  }
  .actions >>> .ivu-btn{
    border-radius: 2px;
    width: 130px;
    font-size: 16px;
  }
  .actions >>> .ivu-btn .ivu-icon-ios-search{
    background: url("~@/assets/images/home/add.png") 0 center no-repeat transparent;
    background-size: 14px;
    width: 14px;
    height: 14px;
    position: relative;
    top: 2px;
  }
  .actions >>> .upload.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/import.png");
  }
  .actions >>> .del.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/del.png");
  }
  .actions >>> .reset.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/import.png");
  }
  .actions >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
    margin-left: 2px;
  }
  .actions >>> .ivu-btn .ivu-icon-ios-search:before{
    content: "";
  }
  .actions .upload{
    border: 1px solid #00B55F;
    color: #00B55F;
  }
  .actions .del{
    border: 1px solid #8ac3fa;
    background-color: #8ac3fa;
    color: #fff;
    margin-right: 20px;
  }
  .actions .reset{
    border: 1px solid #ffa799;
    background-color: #ffa799;
    color: #fff;
  }
  .material_list{
    position: relative;
  }
  .table-containter{
    position: relative;
    /* overflow-x: auto;
    overflow-y: hidden; */
    padding-bottom: 3px;
  }
  .edit {
    background-color: #8892f3;
    color: #fff;
    margin-right: 20px;
}
  .table-wrap{
    width: 100%;
    border: 1px solid #eaf7ff;
  }
/* .table-containter::-webkit-scrollbar-track-piece {
  background: transparent;
}
.table-containter::-webkit-scrollbar {
  height: 6px;
}
.table-containter::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
} */
.table-wrap >>> .ivu-table-wrapper{
  /* width: 1500px; */
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td{
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table:before, .table-wrap >>> .ivu-table:after{
  background-color: #eaf7ff;
}
  .material_list >>> .ivu-table-wrapper{
    border: 0 none;
    /* box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50); */
  }
  .material_list >>> .ivu-table{
    color: #686765;
  }
  .material_list >>> .ivu-table th{
    background-color: #eaf7ff;
    font-size: 14px;
    font-weight: normal;
    border-color: #eaf7ff;
  }
  .material_list >>> .ivu-table th .ivu-table-cell{
    white-space: nowrap;
    font-size: 16px;
    color: #333;
  }
  .material_list >>> .ivu-table td{
    font-size: 16px;
    border-width: 0;
  }
  .material_list >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .material_list >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .material_list >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .material_list >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .files >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .files{
    margin: 10px 0 25px;
  }
  .btns{
    margin: 30px auto 0;
    text-align: center;
  }
  .btn{
    width: 130px;
    border: 1px solid #0774b5;
    border-radius: 3px;
    height: 32px;
    /*line-height: 32px;*/
    /*float: left;*/
    /*font-size: 12px;*/
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    background-color: #0774b5;
    color: #fff;
    margin: 0 16px;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
.invoice_container >>> .tgroup_wrap{
  position: relative;
  padding-right: 73px;
}
.invoice_container >>> .tgroup_wrap .tgroup_item2{
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width:70px;
  margin-top: 0.5px;
}
.invoice_container >>> .tgroup_wrap .ivu-input-number{
  width: 100%;
}
.invoice_container >>> .tgroup_wrap_tb .ivu-input-number{
  margin-right: 2px;
}
.invoice_container >>> .tgroup_wrap_tb .tgroup_item2{
  width: 64px;
}
.invoice_container >>> .material_list .ivu-input,
.invoice_container >>> .material_list .ivu-select-selected-value,
.invoice_container >>> .material_list .ivu-select-item,
.invoice_container >>> .material_list .ivu-input-number-input,
.invoice_container >>> .material_list .ivu-select-placeholder{
  font-size: 14px !important;
}
.inputs >>> .search-input-item{
  border: 0 none;
}
.inputs >>> .wrap{
  padding: 0 !important;
}
.inputs >>> .wrap .title{
  display: none;
}
.inputs >>> .wrap .value{
  margin: 0 !important;
  border-color: #b1b1b1 !important;
  position: relative;
  top: 1px;
  font-size: 0;
  height: 32px;
}
.inputs >>> .wrap .value .input{
  font-size: 16px;
 
  position: relative;
  height: 29px;
  top: 1px;
}
.inputs >>> .pr .dropdown{
  width: 160%;
  margin-top: 1px;
}
.material_list >>> .opr{
  font-size: 14px;
}
.material_list >>> .row-save, .material_list >>> .row-cancel{
  font-size: 14px;
  color: #fff;
  background-color: #13ce66;
  border-color: #13ce66;
  padding: 5px 10px;
  border-radius: 6px;
  margin-right: 8px;
  white-space: nowrap;
}
.material_list >>> .row-save:hover{
  background-color: #06a74d;
  border-color: #06a74d;
}
.material_list >>> .row-cancel{
  margin-right: 0;
  background-color: #ffba00;
  border-color: #ffba00;
}
.material_list >>> .row-cancel:hover{
  background-color: #f5c84f;
  border-color: #f5c84f;
}
.specialCodes{
  margin: 0 10px;
}
.specialCodes .center{
  display: inline-block;
  margin:0px 10px
}
.specialCodes  span{
  vertical-align: middle;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/AddContent.vue